/**
 * SectionWelcome — welcome text shown under section headings
 * Has a subtle backing in scene themes to remain readable
 */
export default function SectionWelcome({ text, className = '' }) {
  if (!text) return null
  return (
    <p className={`section-welcome ${className}`}>{text}</p>
  )
}
